module.exports = __webpack_public_path__ + "5b1d3abb61c42d212a44946b99008e20.svg";